import type { TefComs4csMicroFrontend } from '@mfe-4cs/components/tef-coms4cs';
import { html, TemplateResult } from 'lit';
import { runInAction } from 'mobx';
import comsStore from '@mfe-4cs/state/ComsStore';
import { TefComs } from '@mfe-4cs/types/typings';

export function referencesTemplate(this: TefComs4csMicroFrontend, references: TefComs.Reference[]): TemplateResult {
  const onAddNew = () => {
    runInAction(() => {
      comsStore.references.push({
        type: 'Voice',
        source: 'CCT',
        id: '',
        state: 'inEdit',
      });
    });
  };

  const referenceItemTemplate = this.getTemplateFn('referenceItemTemplate');

  return html`
  <div class="section">
    <div class="container-fluid">
      <h3 class="typography-display--3" style="display: flex; justify-content: space-between;">
        <span>
          Dokumente
        </span>
        <a @click=${onAddNew}>
          Reference hinzufügen
        </a>
      </h3>
      ${references.map((ref) => referenceItemTemplate(ref))}
      </div>
    </div>
  </div>`;
}
